var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reading-app",attrs:{"id":"app"}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.infoObj.goodsName))]),_c('div',{staticClass:"goodsIntro",domProps:{"innerHTML":_vm._s(_vm.infoObj.goodsIntro)}}),_c('FootTab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }